import useSWR from "swr";

export const useAssigneeList = (keyword?: string) =>
  useSWR(
    keyword
      ? `/api/dataservice/v1/metadata/user-search?keyword=${keyword}`
      : `/api/dataservice/v1/metadata/user-search`
  );

export const useTodoList = (timezone: string, tab: string) =>
  useSWR(`/api/dataservice/v1/todos?userTimezone=${timezone}&tab=${tab}`);

export const useTimezones = () => useSWR(`/api/timezones`);

export const useTeamAssigneeList = () => useSWR(`/api/dataservice/v1/metadata/my-team-users`);
